import ClientsService from "../../../services/ClientsService";
import {
  IClientsCountDto,
  PaginatedListOfClientInfoDto,
  UserInviteStatus,
} from "@growth-machine-llc/stridist-api-client";
import {
  predicateQueryKeyByParams,
  useOptimisticUpdateMutation,
} from "../../../hooks/useOptimisticUpdateMutation";
import { COACH_CLIENTS_LIST_QUERY_KEY } from "../CoachClientsListScreen";
import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import { COACH_PENDING_CLIENTS_COUNT_QUERY_KEY } from "../../../wrappers/router/coach/CoachClientsWrapper";

export default function useRevokeAddedClientMutation() {
  const queryClient = useQueryClient();
  return useOptimisticUpdateMutation({
    queryKey: [
      COACH_CLIENTS_LIST_QUERY_KEY,
      { status: [UserInviteStatus.PENDING, UserInviteStatus.ADDED] },
    ],
    mutationFn: ClientsService.revokeAddedClient,
    optimisticUpdater: {
      updateFn: (store: PaginatedListOfClientInfoDto, id) => {
        store.items = store.items?.filter((addedUser) => addedUser.id !== id);
        return store;
      },
    },
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            COACH_CLIENTS_LIST_QUERY_KEY,
            { isDialog: true, status: [UserInviteStatus.ADDED] },
          ],
        });

        queryClient.setQueryData<IClientsCountDto>(
          [COACH_PENDING_CLIENTS_COUNT_QUERY_KEY],
          (prev) => (prev ? { ...prev, count: prev.count - 1 } : prev),
        );
      },
    },
  });
}
